export default "__VITE_ASSET__DdHLK6Hq__"